import { c as _c } from "react/compiler-runtime";
import type { UserPageStatsActivityWalletFilterType } from "../UserPageStatsActivityWallet";
export default function UserPageStatsActivityWalletFilterItem(t0) {
  const $ = _c(14);
  const {
    filter,
    title,
    activeFilter,
    onFilter
  } = t0;
  let t1;
  if ($[0] !== filter || $[1] !== onFilter) {
    t1 = () => onFilter(filter);
    $[0] = filter;
    $[1] = onFilter;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== title) {
    t2 = <span className="tw-text-sm tw-font-medium tw-text-white">{title}</span>;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeFilter || $[6] !== filter) {
    t3 = filter === activeFilter && <svg className="tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[5] = activeFilter;
    $[6] = filter;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="tw-w-44 tw-truncate">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t4) {
    t5 = <li><button className="tw-bg-transparent tw-border-none tw-text-left tw-w-full tw-h-full tw-flex tw-items-center tw-justify-between tw-text-white tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-p-2 hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out" onClick={t1}>{t4}</button></li>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}